/* GENERATED by scripts/gen-data.mjs — chapter "event-bus" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_EVENT_BUS: NodeDef = {
  "id": "event-bus",
  "tagKey": "path:event-bus.tag",
  "x": 1160,
  "y": 40,
  "w": 220,
  "h": 116,
  "titleKey": "path:event-bus.title",
  "subKey": "path:event-bus.sub",
  "blocks": [
    {
      "id": "event-bus.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:event-bus.b1.title",
      "bodyKey": "path:event-bus.b1.body",
      "flowKey": "path:event-bus.b1.flow"
    },
    {
      "id": "event-bus.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:event-bus.b2.title",
      "film": "f-bus"
    },
    {
      "id": "event-bus.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:event-bus.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:event-bus.b3o.opts.0.n",
            "wKey": "path:event-bus.b3o.opts.0.w",
            "uKey": "path:event-bus.b3o.opts.0.u",
            "cKey": "path:event-bus.b3o.opts.0.c",
            "slug": "synchronous-call"
          },
          {
            "nKey": "path:event-bus.b3o.opts.1.n",
            "wKey": "path:event-bus.b3o.opts.1.w",
            "uKey": "path:event-bus.b3o.opts.1.u",
            "cKey": "path:event-bus.b3o.opts.1.c",
            "slug": "in-process-queue"
          },
          {
            "nKey": "path:event-bus.b3o.opts.2.n",
            "wKey": "path:event-bus.b3o.opts.2.w",
            "uKey": "path:event-bus.b3o.opts.2.u",
            "cKey": "path:event-bus.b3o.opts.2.c",
            "slug": "durable-log"
          },
          {
            "nKey": "path:event-bus.b3o.opts.3.n",
            "wKey": "path:event-bus.b3o.opts.3.w",
            "uKey": "path:event-bus.b3o.opts.3.u",
            "cKey": "path:event-bus.b3o.opts.3.c",
            "slug": "transient-pub-sub"
          },
          {
            "nKey": "path:event-bus.b3o.opts.4.n",
            "wKey": "path:event-bus.b3o.opts.4.w",
            "uKey": "path:event-bus.b3o.opts.4.u",
            "cKey": "path:event-bus.b3o.opts.4.c",
            "slug": "outbox-dead-letter"
          }
        ],
        "ref": "kafkaflink"
      }
    },
    {
      "id": "event-bus.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:event-bus.b3.title",
      "math": {
        "exprKey": "path:event-bus.b3.math.expr",
        "readKey": "path:event-bus.b3.math.read",
        "useKey": "path:event-bus.b3.math.use",
        "ref": "littles"
      }
    },
    {
      "id": "event-bus.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:event-bus.b4.title",
      "ex": {
        "type": "order",
        "items": [
          {
            "tKey": "path:event-bus.b4.ex.items.0.t",
            "whyKey": "path:event-bus.b4.ex.items.0.why"
          },
          {
            "tKey": "path:event-bus.b4.ex.items.1.t",
            "whyKey": "path:event-bus.b4.ex.items.1.why"
          },
          {
            "tKey": "path:event-bus.b4.ex.items.2.t",
            "whyKey": "path:event-bus.b4.ex.items.2.why"
          },
          {
            "tKey": "path:event-bus.b4.ex.items.3.t",
            "whyKey": "path:event-bus.b4.ex.items.3.why"
          },
          {
            "tKey": "path:event-bus.b4.ex.items.4.t",
            "whyKey": "path:event-bus.b4.ex.items.4.why"
          }
        ]
      }
    }
  ]
};
